import { type Atom, atom } from "jotai";

export function lazyAtom<T>(init: () => Atom<T>): Atom<T> {
  let innerAtom: Atom<T> | undefined;
  return atom((get) => {
    innerAtom ??= init();
    return get(innerAtom);
  });
}
